import React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
})

export default ({children, open, fullWidth, maxWidth, classes, onClose, disablePortal, PaperProps}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        classes={classes}
        TransitionComponent={Transition}
        disablePortal={disablePortal}
		PaperProps={PaperProps}
    >
        {children}
    </Dialog>
)
